import { RootState } from 'store';

export const selectNavCollapsed = (state: RootState) => state.setting.navCollapsed;
